module.exports = __webpack_public_path__ + "img/mercedes.d8cb43fd.png";